export class ChatApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns ChatUserResponseDto Returns the current user
     * @throws ApiError
     */
    me() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/chat/user',
        });
    }
    /**
     * @returns UserWorkspacesResponseDto Returns the current user and their workspaces
     * @throws ApiError
     */
    getWorkspaces() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/chat/workspaces',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    joinWorkspace({ workspaceIdOrSlug, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/chat/workspaces/{workspaceIdOrSlug}/join',
            path: {
                'workspaceIdOrSlug': workspaceIdOrSlug,
            },
        });
    }
    /**
     * @deprecated
     * @returns ChatMessage
     * @throws ApiError
     */
    chatMessages({ chatId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/chat/{chatId}/messages',
            path: {
                'chatId': chatId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    genChatMessages({ chatId, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/chat/{chatId}/gen-test-messages',
            path: {
                'chatId': chatId,
            },
        });
    }
    /**
     * @returns PaginatedChatMessagesDto Returns the paginated chat messages
     * @throws ApiError
     */
    paginatedChatMessages({ chatId, before, after, limit, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/chat/{chatId}/messages/paginated',
            path: {
                'chatId': chatId,
            },
            query: {
                'before': before,
                'after': after,
                'limit': limit,
            },
        });
    }
    /**
     * @returns ChatMessageAttachment
     * @throws ApiError
     */
    saveAttachment({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/chat/attachments',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ChatMessageAttachment
     * @throws ApiError
     */
    getUserAttachments({ chatUserId, pageSize, page, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/chat/user/{chatUserId}/attachments',
            path: {
                'chatUserId': chatUserId,
            },
            query: {
                'pageSize': pageSize,
                'page': page,
            },
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    getUnreadCount({ chatId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/chat/{chatId}/unread-count',
            path: {
                'chatId': chatId,
            },
        });
    }
    /**
     * @returns ChatMetadataDto
     * @throws ApiError
     */
    getChatMetadata({ chatId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/chat/{chatId}/metadata',
            path: {
                'chatId': chatId,
            },
        });
    }
}
